export const JOURNEY_STAGE_TONES = [
  {
    section: 'border-blue-300 bg-white dark:border-blue-700 dark:bg-slate-800',
    header: 'border-blue-300 bg-blue-50 dark:border-blue-700 dark:bg-blue-950/35',
    badge: 'bg-blue-700 text-white dark:bg-blue-500',
  },
  {
    section: 'border-cyan-300 bg-white dark:border-cyan-700 dark:bg-slate-800',
    header: 'border-cyan-300 bg-cyan-50 dark:border-cyan-700 dark:bg-cyan-950/35',
    badge: 'bg-cyan-700 text-white dark:bg-cyan-500',
  },
  {
    section: 'border-violet-300 bg-white dark:border-violet-700 dark:bg-slate-800',
    header: 'border-violet-300 bg-violet-50 dark:border-violet-700 dark:bg-violet-950/35',
    badge: 'bg-violet-700 text-white dark:bg-violet-500',
  },
  {
    section: 'border-teal-300 bg-white dark:border-teal-700 dark:bg-slate-800',
    header: 'border-teal-300 bg-teal-50 dark:border-teal-700 dark:bg-teal-950/35',
    badge: 'bg-teal-700 text-white dark:bg-teal-500',
  },
  {
    section: 'border-indigo-300 bg-white dark:border-indigo-700 dark:bg-slate-800',
    header: 'border-indigo-300 bg-indigo-50 dark:border-indigo-700 dark:bg-indigo-950/35',
    badge: 'bg-indigo-700 text-white dark:bg-indigo-500',
  },
];

export function journeyStageTone(index = 0) {
  return JOURNEY_STAGE_TONES[index % JOURNEY_STAGE_TONES.length];
}

export function firstSentencePreview(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  const match = text.match(/^.*?(?:[.!?](?=\s|$)|[。！？؟۔।])/u);
  return match ? match[0].trim() : text;
}
